import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(form.email.trim(), form.password);
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (e) {
      const detail = e.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "#F5F7FA" }}>
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
        <div className="flex items-center gap-2 leading-none">
          <img src="/logo.png" alt="OpSysDigital" className="h-11 w-auto" />
          <span className="ml-auto text-[10.5px] uppercase tracking-[0.16em] text-[#6B7A8D]">Admin</span>
        </div>
        <div className="mt-8 flex items-center gap-3">
          <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "#0F2A6E", color: "white" }}>
            <Lock size={18} weight="duotone" />
          </div>
          <div>
            <div className="font-heading font-semibold text-[18px]" style={{ color: "#0F2A6E" }}>Sign in</div>
            <div className="text-[12.5px] text-[#6B7A8D]">Manage content and view analytics</div>
          </div>
        </div>

        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="admin-email"
              value={form.email}
              onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
              className="mt-1.5" required autoFocus />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="admin-password"
              value={form.password}
              onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
              className="mt-1.5" required />
          </div>
          {err && <div className="text-[12.5px]" style={{ color: "#1B6FE0" }} data-testid="admin-login-error">{err}</div>}
          <Button type="submit" disabled={busy} data-testid="admin-login-submit"
            className="w-full h-11 text-white font-medium" style={{ background: "#1B6FE0" }}>
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
